import axios from 'axios';
import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';

export default class ContactForm extends Component {
	constructor({ url = 'submitform' }) {
		super({
			element: '.contact',
			elements: {
				form: '.contact__form',
				left: '.contact__left',
				btn: '.contact__form-button',
			},
		});

		this.formUrl = url;
		this.timer = null;
		this.timeSteps = 0;
		this.reqAttempts = 0;
	}

	create() {
		super.createComponent();
		console.log(this.elements.form);
		console.log(this.elements.left);
		// Fix Element Left using GSAP Scroll trigger
		const mediaQuery = window.matchMedia('(min-width: 1000px)');
		if (mediaQuery.matches) this.fixElementLeft();
	}

	errorTimer() {
		if (this.reqAttempts > 2) {
			this.elements.btn.textContent = 'Try again later';
			return;
		}
		this.timer = setInterval(() => {
			this.timeSteps++;
			if (this.timeSteps > 5) {
				clearInterval(this.timer);
				this.animate('default');
				this.reqAttempts += 1;
				this.timer = null;
				this.timeSteps = 0;
			} else {
				this.elements.btn.textContent = `Error! (${6 - this.timeSteps})`;
			}
		}, 1000);
	}

	animate(e) {
		console.log('animate', e);
		this.elements.btn.classList.add('btn--disabled');
		switch (e) {
			case 'loading':
				this.elements.btn.textContent = 'Loading...';
				break;
			case 'success':
				this.elements.btn.textContent = 'Success!';
				this.elements.btn.classList.add('btn--success');
				break;
			case 'error':
				this.elements.btn.textContent = 'Error!';
				this.elements.btn.classList.add('btn--error');
				this.errorTimer();
				break;
			case 'default':
				this.elements.btn.classList.remove('btn--disabled');
				this.elements.btn.classList.remove('btn--success');
				this.elements.btn.classList.remove('btn--error');
				this.elements.btn.textContent = 'Submit Form';
				break;
			default:
				break;
		}
	}

	fixElementLeft() {
		GSAP.to(this.elements.left, {
			scrollTrigger: {
				trigger: this.elements.left,
				start: 'top top',
				end: 'center top',
				pin: true,
				pinSpacing: false,
			},
		});
	}

	submitForm(e) {
		e.preventDefault();
		console.log('SUBMIT FORM');
		this.animate('loading');

		// Get data from form and add it to an object
		const finalData = {};
		const formData = new FormData(this.elements.form);

		[...formData].map((info) => {
			finalData[info[0]] = info[1];
		});

		console.log(finalData);

		// Send the object via axios
		this.sendData(finalData);
	}

	async sendData(data) {
		try {
			await axios.post(`${this.formUrl}`, data);
			this.animate('success');
		} catch (error) {
			console.error(error.message);
			this.animate('error');
		}
	}

	addEventListeners() {
		this.elements.form.addEventListener('submit', (e) => this.submitForm(e));
	}

	removeEventListeners() {
		this.elements.form.removeEventListener('submit', (e) => this.submitForm(e));
	}

	destroy() {
		GSAP.killTweensOf(this.elements.left);
	}
}
